<template>
    <div>
            
        <app-icon-list v-if="showplacementTypes" :fetchedObject="fetchedPlacementType" :key="'PLACEMENT' + placementTypeReloadKey" :type="'PLACEMENTTYPE'" :title="$t('choose_adtype_for_ad')"
            :selectedApps="selectedApps" :selectedObject="selectedPlacementType" :showcheckbox="false" :showoutline="true"
            @pushselectedPlacementType="pushselectedPlacementType" :objects="placementTypes"></app-icon-list>
          
        <div v-if="showAccounts || selectedPlacementType != null && selectedPlacementType.appSpecificData != null " class="card">
              <div class="card-header">
                <h5>{{ $t("choose_profile_for_ad") }}</h5>
              </div>
              <div class="card-body py2">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">{{ $t("profile") }}</th>
                                <th scope="col">{{ $t("email") }}</th>
                                <!-- <th scope="col">{{ $t("actions") }}</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="accounts.length == 0">
                                <th colspan="3">{{ $t("no_entries") }}</th>
                            </tr>
                            <tr v-for="(account, index) in accounts" :key="index">
                                <td><input :checked="account == selectedAccount" @click="selectAccount(account)"
                                        class="app-checkbox" type="checkbox" /></td>
                                <td>{{ account.image }} {{ account.userName }}</td>
                                <td>{{ account.email }}</td>
                                <!-- <td>
                                    <button class="btn btn-danger" @click="deleteAccount(account.id)"> <trash-icon
                                            size="16"></trash-icon></button>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
              </div>
            </div>

            <div v-if="showSpecificData || selectedPlacementType != null && selectedPlacementType.appSpecificData != null && selectedPlacementType.appSpecificData.uniqueName != 'USER'" class="card">
              <div class="card-header">
                <h5>{{ $t("choose_data_for_ad") }}</h5>
              </div>
              <div class="card-body py2">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">{{ $t("image") }}</th>
                                <th scope="col">{{ $t("description") }}</th>
                                <th scope="col">{{ $t("createdAt") }}</th>
                                <!-- <th scope="col">{{ $t("actions") }}</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="accounts.length == 0">
                                <th colspan="3">{{ $t("no_entries") }}</th>
                            </tr>
                            <tr v-for="(data, index) in specificData" :key="index">
                                <td><input :checked="data == selectedSpecificData" @click="selectedSpecificData = data"
                                        class="app-checkbox" type="checkbox" /></td>
                                <td><v-img class="rounded-lg" :src="selectedApp.imagePrefixUrl + data.image" width="40"
                                        :aspect-ratio="1"></v-img></td>
                                <td>{{ data.description }}</td>
                                <td>{{ $formatDateTime(data.createdAt) }}</td>
                                <!-- <td>
                                    <button class="btn btn-danger" @click="deleteAccount(account.id)"> <trash-icon
                                            size="16"></trash-icon></button>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                    <div>
                        <pagination ref="pagination" :show-previous-page="prevPage" :show-next-page="nextPage"
                           :totalPages="totalPages" :currentPage="page"></pagination>
                    </div>
                </div>
              </div>
            </div>

            <app-icon-list v-if="showplacements" :key="'PLACEMENT' + placementReloadKey" :type="'PLACEMENT'" :title="$t('choose_placement_for_ad')"
            :selectedApps="selectedApps" :selectedObject="selectedPlacement" :showcheckbox="false" :showoutline="true"
            @pushselectedPlacement="pushselectedPlacement" :fetchedObject="fetchedPlacement" :objects="placements"></app-icon-list>

        <div v-if="showContent || selectedPlacementType != null && !selectedPlacementType.profileConnected && selectedPlacementType.appSpecificData == null" class="card">
              <div class="card-header">
                <h5>{{ $t('choose_content_for_ad') }}</h5>
              </div>
              <div class="card-body py2">
                <LanguagePicker v-model="selectedLanguage" className="top-right-28" />
                <div class="form theme-form">
                    <div class="row">
                        <div class="col-12 col-xl-4 px-0 px-md-3 ">
                            <div class="mb-3">
                                <label>{{ $t("description") }}</label>
                                <v-textarea v-model="descriptions[selectedLanguage]"
                                    class="datainput justify-content-end align-self-center pb-1" dense outlined
                                    hide-details="auto"></v-textarea>
                            </div>
                            <div class="mb-3">
                                <label>{{ $t("targetURL") }}</label>
                                <v-text-field v-model="targetUrl"
                                    class="datainput justify-content-end align-self-center pb-1" dense outlined
                                    hide-details="auto" dence></v-text-field>
                            </div>
                        </div>
                        <div v-if="showMap"
                            class="col-12 col-xl-4 px-0 px-md-3 ">
                            <label>{{ $t("location") }}*</label>
                            <vue-google-autocomplete id="map" classname="form-control" :placeholder="$t('search_address')" types="address" v-on:placechanged="googleAutocompleteChanged">
                            </vue-google-autocomplete>
                            <l-map ref="map" @click="addMarker" :zoom="map.zoom"
                                :center="[map.center.latitude, map.center.longitude]"
                                style="height: 300px; width: 100%;z-index: 1;">
                                <l-tile-layer :url="map.url" :attribution="map.attribution" />
                                <l-marker v-for="marker, index in map.markers" :key="index" :lat-lng="marker"
                                    @click="removeMarker(index)" />
                                <!-- <l-circle v-for="marker, index in map.markers" :key="index" :lat-lng="marker"
                                    :radius="filter.radius * 1000" :color="'#4FA4BA'" /> -->
                            </l-map>
                        </div>

                        <div
                            class="col-12 col-xl-4 px-0 px-md-3 ">
                            <div class="mb-3">
                                <label>{{ $t("image") }}*</label>
                                <UploadToS3 v-model="images[selectedLanguage]" :label="''"></UploadToS3>
                            </div>
                        </div>
                    </div>
                </div>
                
              </div>
            </div>


        

        <!-- <div class="card" v-if="selectedPlacementType != null && !selectedPlacementType.profileConnected && selectedPlacementType.appSpecificData == null">
            <div class="card-header pb-0">
                <h5>{{ $t('choose_content_for_ad') }}</h5>
            </div>
            <LanguagePicker v-model="selectedLanguage" />
            <div class="card-body py2 py-2">
                

            </div>
        </div> -->

    </div>
</template>

<script>
import Pagination from '../custom/pagination.vue';
import VueGoogleAutocomplete from "vue-google-autocomplete";
import AppIconCheck from './AppIconCheck.vue';
import AppIconList from './AppIconList.vue';
export default {
    name: "AdvertisementSelect",

    components: {
        AppIconCheck,
        AppIconList,
        Pagination,
        VueGoogleAutocomplete
    },
    created(){
    },

    mounted() {
        this.descriptions = this.fetchedDescriptions == null ? {} : this.fetchedDescriptions;
        this.targetUrl = this.fetchedTargetUrl;
        // this.images = this.fetchedImages;

        
    },


    watch: {
        fetchedLocation:{
            handler(val){
                console.log(val);
                if((val.lat == null && val.lng == null) || (val.lat == 0 && val.lng == 0) || (val.lat == "" && val.lng == "")){
                    navigator.geolocation.getCurrentPosition((loc) => {
                        this.map.center.latitude = loc.coords.latitude;
                        this.map.center.longitude = loc.coords.longitude;
                    })
                }else{
                    this.addMarker({ latlng: { lat: val.lat, lng: val.lng } });
                    this.map.center.latitude = val.lat;
                    this.map.center.longitude = val.lng;
                }
            },
            deep:true,
        },
        fetchedImages:{
            handler(val){
                this.images = this.fetchedImages;
            },
            deep:true,
        },
        fetchedDescriptions:{
            handler(val){
                this.descriptions = val == null ? {} : val;
            },
            deep:true,
        },
        fetchedTargetUrl:function(val){
            this.targetUrl = this.fetchedTargetUrl;
        },
        fetchedTargetUrlType:function(val){
            this.targetUrlType = this.fetchedTargetUrlType;
        },
        fetchedTargetAccountId:function(val){
            this.targetAccountId = this.fetchedTargetAccountId;
        },
        fetchedPlacementType:{
            handler(val) {
                if(Object.keys(Object.assign({}, val)).length !== 0){
                    this.placementTypeReloadKey++;
                    if(this.fetchedPlacementType !=null && this.fetchedPlacementType.appSpecificData == null && !this.fetchedPlacementType.profileConnected){
                        this.showContent = true;
                        
                    }else if(this.fetchedPlacementType !=null && this.fetchedPlacementType.profileConnected && this.fetchedPlacementType.appSpecificData == null){
                        this.showContent = false;
                    }
                    
    
                    // console.log(val);

                    if (val.profileConnected) {
                        this.fetchAccounts(true);
                        this.showAccounts = true;
                        // this.selectedSpecificData = this.fetchedPlacementType.appSpecificData;
                        // console.log(this.selectedSpecificData);
                    } else {
                        this.showSpecificData = false;
                        this.showAccounts = false;
                        this.selectedSpecificData = null;
                        this.targetUrlType = null;
                        this.targetUrl = "";
                    }
                
                }
            },
            deep: true
        },
        fetchedPlacement:{
            handler(val) {
                if(Object.keys(Object.assign({}, val)).length !== 0){
                  this.placementReloadKey++;

                  if(this.fetchedPlacement != null && this.fetchedPlacement.type == 'MAP'){
                        this.showMap = true;
                    }
                }
            },
            deep: true
        },
        images:{
            handler(val) {
                // console.log(val);
                if(val == null || val.length == 0) val = null;
                this.$emit("getImages", val);
            },
            deep: true
        },
        targetLocation: {
            handler(val) {
                
                this.$emit("getTargetLocation", val);
            },
            deep: true
        },
        descriptions: {
            handler(val) {
                this.$emit("getDescriptions", val);
            },
            deep: true
        },
        targetUrl: function (val) {
            this.$emit("getTargetUrl", { targetUrl: this.targetUrl, targetUrlType: this.targetUrlType })
        },
        specificData: function (val) {
            if (val.length == 0) {
                this.skip = 0;
            }
            if (val.length < 5) {
                if (this.skip / this.limit != 0) {
                    this.totalPages = this.skip / this.limit
                }
            }
        },
        selectedSpecificData: function (val) {
            if (this.selectedPlacementType != null && this.selectedPlacementType.appSpecificData != null && this.selectedPlacementType.appSpecificData.uniqueName != 'USER'|| 
                this.fetchedPlacementType != null && this.fetchedPlacementType.appSpecificData != null && this.fetchedPlacementType.appSpecificData.uniqueName != 'USER') {
                this.targetUrlType = this.selectedPlacementType == null ? this.fetchedPlacementType.appSpecificData.type: this.selectedPlacementType.appSpecificData.type;
                this.targetUrl = val.id;
                if(Array.isArray(val.image)){
                    this.images[this.$locale] = val.image[0];
                }else{
                    this.images[this.$locale] = val.image;
                }
                this.$emit("getImages", this.images);
            }
            // console.log('EMIT SPECIFIC',val);
            this.$emit('getSelectedSpecificData', val);
        },
        targetAccountId: function(val){
            // console.log(val);
            if(val != null){
                this.$emit('getTargetAccountId',val);
            }
        },
        selectedAccount: function (val) {
            if (Object.keys(val).length != 0) {
                // console.log(val);
                if (this.selectedPlacementType != null && this.selectedPlacementType.appSpecificData != null && this.selectedPlacementType.appSpecificData.uniqueName != 'USER' || 
                this.fetchedPlacementType != null && this.fetchedPlacementType.appSpecificData != null && this.fetchedPlacementType.appSpecificData.uniqueName != 'USER') {
                    this.fetchSpecificData(true);
                    this.showSpecificData = true;
                } else {
                    this.targetUrlType = 'USER';
                    this.targetUrl = val.etsId;
                    // console.log(val.userImage);
                    this.images[this.$locale] = val.userImage; 
                    // console.log(this.images);
                    this.$emit("getImages", this.images);
                    
                }
                // console.log("SET ACCID",val.etsId);
                this.targetAccountId = val.etsId;
                // console.log(this.targetAccountId)

                


            } else if (Object.keys(val).length == 0) {
                this.specificData = [];
                this.showSpecificData = false;
                this.targetAccountId = "";
            }
        },
        selectedPlacementType: function (val) {
            console.log(val);
            this.$emit('getSelectedPlacementType', val);
            if (Object.keys(val).length == 0) {
                this.accounts = [];
                this.showAccounts = false;
                this.selectedAccount = {};
                this.specificData = [];
                this.page = 0;
                this.totalPages = 600;
                lastUsers = null;
                // this.placements = [];
            }

            this.selectedPlacement = {};

            
            
            if(this.selectedPlacementType !=null && this.selectedPlacementType.appSpecificData == null && !this.selectedPlacementType.profileConnected){
                this.showContent = true;
                
            }else if(this.selectedPlacementType !=null && this.selectedPlacementType.profileConnected && this.selectedPlacementType.appSpecificData == null){
                this.showContent = false;
            }

            // console.log(val);
            
            if (val.profileConnected) {
                this.showAccounts = true;
                this.selectedAccount = {};
                this.fetchAccounts();

            } else {
                this.showSpecificData = false;
                this.showAccounts = false;
                this.selectedSpecificData = null;
                this.targetUrlType = null;
                this.targetUrl = "";
            }
        },
        selectedPlacement: function (val) {

            if(this.selectedPlacement != null && this.selectedPlacement.type == 'MAP'){
                this.showMap = true;
            }

            if(this.selectedPlacement.type != "MAP"){
                this.targetLocation.latitude = null;
                this.targetLocation.longitude = null;
            }

            this.$emit('getSelectedPlacement', val);
        },
        placements: function (val) {
            
            if (val.length > 0) {
                this.showplacements = true;
            } else if (val.length == 0) {
                this.showplacements = false;
            }
        },
        placementTypes: function (val) {
            if (val.length > 0) {
                this.showplacementTypes = true;
                // this.selectedPlacementType = {}
            } else if (val.length == 0) {
                this.showplacementTypes = false;
            }
        }
    },

    props: {
        selectedApp: Object,
        placementTypes: {
            type: Array,
            default: function () {
                return [];
            }
        },
        placements: {
            type: Array,
            default: function () {
                return [];
            }
        },
        fetchedPlacement:Object,
        fetchedPlacementType:Object,
        fetchedDescriptions: Object,
        fetchedImages: Object,
        fetchedTargetUrl: String,
        fetchedTargetUrlType: String,
        fetchedTargetAccountId: String,
        fetchedLocation:Object,

    },

    data() {
        return {
            specificData: [],
            checked: false,
            skip: 0,
            limit: 5,
            totalPages: 15,

            page: 0,
            totalPages: 600,
            ElementPerPage: 5,
            lastUsers: null,

            panel: [0,1,2,3,4,5,6],

            accounts: [],

            placementReloadKey:0,
            placementTypeReloadKey:0,

            selectedApps: [],
            selectedPlacementType: null,
            selectedPlacement: null,
            selectedAccount: null,
            selectedSpecificData: null,

            targetUrlType: null,
            targetUrl: "",
            targetAccountId:"",
            targetLocation: {
                latitude: 0,
                longitude: 0
            },
            descriptions: {},
            images:{},


            showplacements: false,
            showplacementTypes: false,
            showAccounts: false,
            showContent: false,
            showMap:false,
            showSpecificData:false,

            selectedLanguage: this.$locale,

            map: {
                center: {
                    latitude: 0,
                    longitude: 0
                },
                zoom: 10,
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                markers: []
            },

        }
    },

    methods: {
        prevPage() {
            // this.skip = this.skip - this.limit;
            this.page--;
            this.fetchSpecificData();
        },
        nextPage(finddata = false) {
            if(this.page < this.totalPages){
                this.page++;
                this.fetchSpecificData(finddata);
            }else if(this.page <= this.totalPages){
                this.fetchSpecificData(finddata);
            }
            // if (this.specificData.length <= this.ElementPerPage) {
            //     if (this.page * this.ElementPerPage / this.ElementPerPage != 0) {
            //         this.totalPages = this.page * this.ElementPerPage / this.ElementPerPage
            //     }
            // } else {
            //     this.skip = this.skip + this.limit;
            // }
        },
        selectAccount(account) {
            // console.log(account);

            if (this.selectedAccount == null || this.selectedAccount.etsId != account.etsId) {
                this.selectedAccount = account;
            } else {
                this.selectedAccount = {};
            }
        },
        fetchSpecificData(finddata = false) {
            var _this = this;
            var id = _this.selectedPlacementType != null ?  _this.selectedPlacementType.appSpecificData.id : _this.fetchedPlacementType.appSpecificData.id;
            if(_this.selectedPlacementType != null){

            }
            // console.log('_this.selectedPlacementType',_this.selectedPlacementType,_this.selectedPlacementType == null);
            // console.log('_this.fetchedPlacementType',_this.fetchedPlacementType,_this.fetchedPlacementType == null);
            if(this.page <= this.totalPages){
                this.$axios
                    .get("/api/appspecificdata/" + id  + "/data", {
                        params: {
                            userId: _this.selectedAccount.etsId,
                            skip: _this.page * _this.ElementPerPage,
                            limit: _this.ElementPerPage,
                        }
                    })
                    .then(function (response) {
                        _this.lastUsers = response.data.data.length;
                        if(_this.lastUsers < 5) _this.totalPages = _this.page;
                        if(response.data.data.length >= 1){
                            _this.specificData = response.data.data;
                        }
                        if(finddata){
                            _this.findSpecificData();
                        }
                        // _this.totalPages = response.data.totalPages;
                        // _this.$forceUpdate();
                    })
                    .catch(this.onError);

            }
        },
        findSpecificData(){
            // console.log('Start Search', this.specificData);
            const arr = this.specificData;
            for (let i = 0; i < arr.length; i++) {
                const data = arr[i];
                // console.log(data)
                // console.log(data.id)
                // console.log(this.targetUrl);
                if(data.id == this.targetUrl){
                    this.selectedSpecificData = data;
                    // console.log("DATA FOUND", acc);
                    break;
                }
                this.$refs.pagination.nextPage;
            }
            // console.log(this.$refs.pagination);
        },
        fetchAccounts(finduser = false) {
            var _this = this;
            this.$axios
                .get("/api/tenant/connect/ets")
                .then(function (response) {
                    if(response.data.content.length != 0){
                        _this.accounts = response.data.content;
                        _this.showAccounts = true;
                        if(finduser){
                            _this.findAccount();
                        }
                    }
                    else{
                        _this.$noty.error(_this.$t("connect_account_hint"));
                    }
                    _this.$forceUpdate();
                })
                .catch(this.onError);
        },
        findAccount(){
            // console.log('Start Search', this.accounts);
            const arr = this.accounts;
            for (let i = 0; i < arr.length; i++) {
                const acc = arr[i];
                if(acc.etsId == this.targetAccountId){
                    this.selectedAccount = acc;
                    // console.log("USER FOUND", acc);
                    break;
                }
            }
        },
        pushselectedPlacement(event) {
            if (event == null) {
            this.selectedPlacement = event;
            // this.$forceUpdate();
            } else if (event != null) {
                var obj = Object.assign({}, event);
                this.selectedPlacement = obj;
            }
        },
        pushselectedPlacementType(event) {
            console.log(event);
            if (event == null) {
            this.selectedPlacementType = event;
            // this.$forceUpdate();
            } else if (event != null) {
                var obj = Object.assign({}, event);
                this.selectedPlacementType = obj;
            }
        },
        pushSelectedApp(event) {
            var obj = Object.assign({}, event);
            this.selectedApp = obj;
        },
        addMarker(event) {
            if (this.map.markers.length >= 1) { this.removeMarker() }
            this.map.markers.push(event.latlng);
            this.targetLocation.longitude = event.latlng.lng;
            this.targetLocation.latitude = event.latlng.lat;
        },
        removeMarker() {
            this.map.markers.splice(0, 1);
            this.targetLocation.longitude = null;
            this.targetLocation.latitude = null;
        },
        googleAutocompleteChanged(data){
            if (this.map.markers.length >= 1) { this.removeMarker() }
            var coordinates = {
                lat: data.latitude,
                lng: data.longitude
            };
            this.map.markers.push(coordinates);
            this.targetLocation.longitude = data.longitude;
            this.targetLocation.latitude = data.latitude;
            var _this = this;
            Vue.nextTick(() => {
                _this.map.center = {
                    latitude: data.latitude,
                    longitude: data.longitude
                };
                _this.map.zoom = 16;
                _this.$refs.map.mapObject.panTo(_this.map.center);
            });
        }
    },
}
</script>

<style scoped>
.card-header h1,
.card-header>h2,
.card-header>h3,
.card-header>h4,
.card-header>h5 {
    color: #2F3452 !important;
    text-transform: none !important;
}
</style>